module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "msgWindow"
  }, [_c('div', {
    staticClass: "msg-bg",
    style: ({
      width: _vm.clientWidth + 'px',
      height: _vm.clientHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "msg-window"
  }, [_c('div', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('div', {
    staticClass: "msg-btn"
  }, [_c('div', {
    staticClass: "msg-btn-left",
    on: {
      "click": function($event) {
        _vm.btnClick(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnLeft))]), _vm._v(" "), _c('div', {
    staticClass: "msg-btn-right",
    on: {
      "click": function($event) {
        _vm.btnClick(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnRight))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53a2d16f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/msgWindow.vue
// module id = 235
// module chunks = 46